<template>
  <div>
    <ModalCadastroTurma ref="modalCadastroTurma"
                            :tutores="tutores"
                            :turmaEdicao="turmaEdicao"
                            @turmaSalvo="buscarTurmas" />

    <div class="tab-pane fade show active" id="pills-turmas" role="tabpanel" aria-labelledby="pills-turmas-tab">
      <div>
        <a href="javascript:void(0)" class="btn btn-primary mr-3 mb-2 mb-md-0" @click="adicionarTurma()"><i class="fas fa-plus"></i> Adicionar turma</a>&#32;
        <b-link v-b-toggle="'collapse-filter-turmas'" class="btn btn-secondary mr-3 mb-2 mb-md-0"><i class="fas fa-filter"></i> Filtrar lista</b-link>&#32;
      </div>
    </div>

    <b-collapse id="collapse-filter-turmas" class="filtros mt-3">
      <b-card>
        <form v-on:submit.prevent="buscarTurmas">
          <div class="row align-items-center">
            <div class="col-12 col-md-11">
              <div class="row">
                <div class="col-12 col-md-3">
                  <div class="form-group">
                    <label>Turma</label>
                    <input type="text" class="form-control" placeholder="Nome do turma" v-model="filtro.nome" />
                  </div>
                </div>
                <div class="col-12 col-md-3">
                  <div class="form-group">
                    <label>Código</label>
                    <input type="text" class="form-control" placeholder="Código do turma" v-model="filtro.codigo" />
                  </div>
                </div>
              </div>
            </div>
            <div class="col-12 col-md-1">
              <button type="submit" class="btn-primary btn-filtros-busca"><i class="fas fa-search"></i></button>
            </div>
          </div>
        </form>
      </b-card>
    </b-collapse>

    <p class="text-right mt-3" v-if="quantidade"><strong>{{ quantidade }}</strong> itens</p>
    <div class="table-responsive tabela-usuarios mt-2 position-relative" v-if="turmas.length">
      <table class="table">
        <thead>
          <tr>
            <th>Nome</th>
            <th>Código</th>
            <th>Quantidade de Alunos</th>
            <th>Data de Cadastro</th>
            <th>Açoes</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="turma in turmas" v-bind:key="turma.id">
            <td>{{ turma.nome }}</td>
            <td>{{ turma.codigo }}</td>
            <td>{{ turma.users.length }}</td>
            <td>{{ dataCadastro(turma.created_at) }}</td>
            <td>
              <div class="d-flex align-items-center">
                <a href="javascript:void(0)" v-b-tooltip.hover title="Editar" @click="editarTurma(turma)"><i class="fas fa-edit"></i></a>
                <a href="javascript:void(0)" v-b-tooltip.hover title="Excluir" @click="excluirTurma(turma)"><i class="fas fa-trash-alt"></i></a>
              </div>
            </td>
          </tr>
        </tbody>
      </table>

      <transition name="fade">
        <div class="btn-top text-center d-block" v-if="scrolled">
          <a href="javascript:void(0)" @click="scrollToTop"><i class="fas fa-chevron-circle-up"></i>ir para o topo</a>
        </div>
      </transition>

    </div>

    <infinite-loading :identifier="infiniteId" @infinite="infiniteHandler">
      <div slot="no-results">Sua busca não retornou resultados</div>
      <div slot="no-more"></div>
    </infinite-loading>
  </div>
</template>

<script>
import InfiniteLoading from 'vue-infinite-loading'
import DateUtils from '@/core/util/date-utils'
import TurmaAPI from '@/api/turma-api'
import TutorAPI from '@/api/tutor-api'
import ModalCadastroTurma from '@/modules/Conta/components/ModalCadastroTurma'
import ResponseUtils from '@/core/util/response-utils'
import Swal from 'sweetalert2'

export default {
  name: 'ListaTurmas',
  props: {
    perfil: Object
  },
  components: { InfiniteLoading, ModalCadastroTurma },
  data () {
    return {
      pagina: 1,
      quantidade: 0,
      infiniteId: new Date(),
      scrolled: false,
      turmas: [],
      turmaEdicao: null,
      filtro: {
        nome: '',
        codigo: ''
      },
      tutores: []
    }
  },

  created () {
    window.addEventListener('scroll', this.handleScroll)
  },

  destroyed () {
    window.removeEventListener('scroll', this.handleScroll)
  },

  async mounted () {
    this.tutores = await TutorAPI.listar()
  },

  methods: {
    dataCadastro: function (date) {
      if (date !== null) {
        return DateUtils.formatDate(date, 'DD/MM/YYYY')
      }
      return 'Data não informada'
    },

    handleScroll: function (event) {
      this.scrolled = window.scrollY > 100
    },

    scrollToTop: function () {
      window.scroll({ top: 0, left: 0, behavior: 'smooth' })
    },

    buscarTurmas: function () {
      this.quantidade = 0
      this.pagina = 1
      this.infiniteId = new Date()
      this.turmas = []
    },

    adicionarTurma: function () {
      this.turmaEdicao = null
      this.$nextTick(() => {
        this.$refs.modalCadastroTurma.show()
      })
    },

    editarTurma: function (turma) {
      this.turmaEdicao = turma
      this.$nextTick(() => {
        this.$refs.modalCadastroTurma.show()
      })
    },

    excluirTurma: function (turma) {
      Swal.fire({
        title: 'Você deseja excluir esse turma?',
        text: 'Essa ação não poderá ser revertida!',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Sim, excluir turma!',
        cancelButtonText: 'Cancelar'
      }).then((result) => {
        if (result.value) {
          const loader = this.$loading.show()
          TurmaAPI.deletar(turma.id).then(data => {
            loader.hide()
            Swal.fire({
              icon: 'success',
              showCloseButton: true,
              text: 'Turma excluido com sucesso'
            }).then(() => {
              this.buscarTurmas()
            })
          }).catch(error => ResponseUtils.handleError(error, loader))
          loader.hide()
        }
      })
    },
    infiniteHandler: function ($state) {
      TurmaAPI.listar(this.pagina, this.filtro).then(data => {
        this.quantidade = data.total
        if (this.pagina <= data.last_page) {
          this.turmas.push(...data.data.map(item => {
            return item
          }))
          $state.loaded()

          if (this.pagina === data.last_page) {
            $state.complete()
          } else {
            this.pagina += 1
          }
        } else {
          $state.complete()
        }
      })
    }
  }
}
</script>
